globalThis.backoffice = globalThis.backoffice || {};

backoffice.ModalRecordColumnHistory = (function(superClass)
{
    utils.extend(ModalRecordColumnHistory, superClass);

    function ModalRecordColumnHistory($html) {
      return ModalRecordColumnHistory.__super__.constructor.apply(this, arguments);
    }

    $.extend(ModalRecordColumnHistory.prototype, {
      init: function() {
        this.$html.find('[data-popup="tooltip"]').tooltip();

        ModalRecordColumnHistory.__super__.init.apply(this, arguments);
      }
    });

    return ModalRecordColumnHistory;
})(backoffice.ModalMain);
